import { Chart } from '@frontend/chart/types';

export const FILL_RATE_BY_SPOT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'distriSPOT Riverside', data: [{ label: 'full_period', value: 94 }] },
        { name: 'distriSPOT North Gate', data: [{ label: 'full_period', value: 82 }] },
        { name: 'distriSPOT Workshop', data: [{ label: 'full_period', value: 68 }] },
        { name: 'distriSPOT Main Hall', data: [{ label: 'full_period', value: 55 }] }
    ]
};
